import { FlexRow } from 'ui-components/components/flex';

import { useContainsDemoOrder } from '../../../../../../demos/hooks/use-contains-demo-order';
import { useEnableScanToVerifyInOrderDetails } from '../../../../../../feature-flags/hooks/use-enable-scan-to-verify-in-order-details';
import { useFulfillmentPlanIdContext } from '../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import SectionTitle from '../../../../tab-section/title';
import messages from '../messages';
import { ScanToVerifyButtons } from '../scan-to-verify/scan-verify-buttons';
import style from '../shipment-items.module.less';
import EditItemsButton from './edit-items-button';
import { RemoveShipmentButton } from './remove-shipment/remove-shipment-button';
import SplitShipButton from './split-ship-button';
import { ShipmentVerification } from './verified';
import { ToteInfo } from './tote-info';

const Header = () => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const isDemoOrder = useContainsDemoOrder([fulfillmentPlanId]);
  const isScanInOrderDetailsEnabled = useEnableScanToVerifyInOrderDetails();

  return (
    <FlexRow className={style['shipment-items-section-header']}>
      <FlexRow className={style['shipment-items-section-header-labels']}>
        <SectionTitle messageDescriptor={messages.sectionTitle} />
        <ShipmentVerification />
        <ToteInfo />
      </FlexRow>
      <FlexRow className={style['shipment-items-section-header-buttons']}>
        <RemoveShipmentButton />
        <EditItemsButton />
        {!isDemoOrder && <SplitShipButton />}
        {isScanInOrderDetailsEnabled ? <ScanToVerifyButtons /> : null}
      </FlexRow>
    </FlexRow>
  );
};

export { Header };
